// SEO-focused topic seeds per category. Used by the AI generator for
// keyword rotation and to avoid repeating the same theme.

export type BlogCategory =
  | "colecionismo"
  | "equipamentos"
  | "historia"
  | "artistas"
  | "dicas"
  | "mercado";

export const CATEGORY_LABELS: Record<BlogCategory, string> = {
  colecionismo: "Colecionismo",
  equipamentos: "Equipamentos",
  historia: "História",
  artistas: "Artistas",
  dicas: "Dicas",
  mercado: "Mercado",
};

export const CATEGORY_DESCRIPTIONS: Record<BlogCategory, string> = {
  colecionismo: "Cultura de colecionar vinil, garimpo, primeiras prensagens e raridades.",
  equipamentos: "Toca-discos, agulhas, amplificadores e acessórios para colecionadores.",
  historia: "História da indústria fonográfica, selos, prensagens e movimentos musicais.",
  artistas: "Perfis de artistas e discos essenciais do rock, jazz, MPB, samba e mais.",
  dicas: "Guias práticos: limpar, armazenar, avaliar estado e cuidar da coleção.",
  mercado: "Preços, tendências, valorização, mercado brasileiro e internacional de vinil.",
};

export const CATEGORIES = Object.keys(CATEGORY_LABELS) as BlogCategory[];

// Curated topic seeds — used to nudge the AI toward high-intent keywords.
export const TOPIC_SEEDS: Record<BlogCategory, string[]> = {
  colecionismo: [
    "como começar uma coleção de discos de vinil do zero",
    "diferença entre primeira prensagem e reedição de vinil",
    "vinis brasileiros mais raros e valiosos",
    "como identificar uma prensagem original de LP",
    "por que colecionar vinil voltou a ser tendência",
    "coleções de vinil famosas no Brasil",
  ],
  equipamentos: [
    "melhores toca-discos até 2000 reais",
    "como escolher a agulha certa para seu toca-discos",
    "vale a pena investir em pré-amplificador phono",
    "cabo de caixa para som de vinil: importa mesmo?",
    "toca-discos com bluetooth: sim ou não?",
    "kit iniciante de vinil: o que comprar primeiro",
  ],
  historia: [
    "história do vinil no Brasil: da Odeon à retomada atual",
    "por que o CD matou o vinil e como ele ressuscitou",
    "selos brasileiros lendários: Continental, Elenco, Copacabana",
    "a era de ouro do LP: décadas de 60 e 70",
    "como funcionava uma prensagem de vinil nos anos 70",
    "vinis nazistas, comunistas e proibidos: relíquias históricas",
  ],
  artistas: [
    "os melhores discos de MPB para começar uma coleção",
    "Tim Maia em vinil: guia completo de prensagens",
    "Milton Nascimento — discos essenciais para colecionar",
    "Racionais MC's em vinil: por que valorizou tanto",
    "Novos Baianos: LPs originais vs reedições recentes",
    "Legião Urbana em vinil — quais valem o preço",
  ],
  dicas: [
    "como limpar vinil sem danificar sulcos e capa",
    "como armazenar vinil corretamente: temperatura e umidade",
    "vinil arranhado tem conserto? o que funciona de verdade",
    "como avaliar o estado (grading) de um disco de vinil",
    "por que o vinil chia e como resolver isso",
    "como transportar vinil sem estragar",
  ],
  mercado: [
    "quanto vale seu vinil hoje: como pesquisar preço real",
    "vinil está valorizando? panorama do mercado 2026",
    "melhores lojas de vinil no Brasil por cidade",
    "Discogs vs Mercado Livre para vender vinil",
    "quando é hora de vender parte da coleção",
    "importar vinil dos EUA vale a pena?",
  ],
};

export function pickTopicSeed(category: BlogCategory): string {
  const pool = TOPIC_SEEDS[category];
  return pool[Math.floor(Math.random() * pool.length)];
}
